// extracted by mini-css-extract-plugin
export default {"button":"DemoButton_button__a74Fh","arrow":"DemoButton_arrow__-0Tr4","label":"DemoButton_label__4-Cuy"};